export const ERROR_KIND = 'error.kind';
export const ERROR_OBJECT = 'error.object';
export const EVENT = 'event';
export const MESSAGE = 'message';
export const STACK = 'stack';
//# sourceMappingURL=logs.js.map